import { render, staticRenderFns } from "./ReceptionProductsUpdate.vue?vue&type=template&id=72965a71&scoped=true"
import script from "./ReceptionProductsUpdate.vue?vue&type=script&lang=js"
export * from "./ReceptionProductsUpdate.vue?vue&type=script&lang=js"
import style0 from "./ReceptionProductsUpdate.vue?vue&type=style&index=0&id=72965a71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72965a71",
  null
  
)

export default component.exports